import * as React from 'react';
import { tokens } from 'src/design-system';

export default ({ containerDetails, lclPackageTypes }) => {
  if (containerDetails.length >= 2) {
    const [
        { type: type1, count: count1, volume: { value: value1, unit: unit1 } },
        { type: type2, count: count2, volume: { value: value2, unit: unit2 } },
    ] = containerDetails;
    return (
        <>
            <div style={{ color: '#424242', fontSize: `${tokens.fontSize.caption}px`, marginBottom: '8px' }}>
                <span style={{ fontWeight: 600 }}>{count1}</span>
                &nbsp;X&nbsp;
                {value1.toFixed(2)} {unit1}
                &nbsp;|&nbsp;<span style={{ fontWeight: 600 }}>{lclPackageTypes[type1]}</span>
            </div>
            <div style={{ color: '#424242', fontSize: `${tokens.fontSize.caption}px`, marginBottom: '8px' }}>
                <span style={{ fontWeight: 600 }}>{count2}</span>
                &nbsp;X&nbsp;
                {value2.toFixed(2)} {unit2}
                &nbsp;|&nbsp;<span style={{ fontWeight: 600 }}>{lclPackageTypes[type2]}</span>
            </div>
            <div
              style={{
                textAlign: 'center',
                color: '#262626',
                fontSize: `${tokens.fontSize.caption}px`,
                fontWeight: tokens.fontWeight.semibold,
              }}>
                {
                  containerDetails.length > 2 ?
                    `+${containerDetails.length - 2} More`
                    : ''
                }
            </div>
        </>
    );
  }
  if (containerDetails.length === 1) {
    const [
        { type, count, volume: { value, unit } },
    ] = containerDetails;
    return (
        <div style={{ color: '#424242', fontSize: `${tokens.fontSize.caption}px`, marginBottom: '8px' }}>
            <span style={{ fontWeight: 600 }}>{count}</span>
            &nbsp;X&nbsp;
            {value.toFixed(2)} {unit}
            &nbsp;|&nbsp;<span style={{ fontWeight: 600 }}>{lclPackageTypes[type]}</span>
        </div>
    );
  }
  return null;
};
